import { render, staticRenderFns } from "./chartsPanel2.vue?vue&type=template&id=18190a82&scoped=true&"
import script from "./chartsPanel2.vue?vue&type=script&lang=js&"
export * from "./chartsPanel2.vue?vue&type=script&lang=js&"
import style0 from "./chartsPanel2.vue?vue&type=style&index=0&id=18190a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18190a82",
  null
  
)

export default component.exports